'use strict';

var silver = require('silver/login/login');

$(document).ready(function () {
    $('#new-member').on('click', function () {
        $(this).removeClass('active');
        $('#login-tab').removeClass('active');
        $('#login-tab').parent().removeClass('active');
        $('#register-tab').addClass('active');
        $('#register-tab').parent().addClass('active');
        setTimeout(() => {
            $('#register').trigger('focus');
            window.scrollTo(0, 0);
        }, 10);
    });

    $('#already-member').on('click', function () {
        setTimeout(() => {
            $('#login').trigger('focus');
            window.scrollTo(0, 0);
        }, 10);
    });
});

module.exports = Object.assign({}, silver, {});
